<template>
  <div>
    <v-sheet outlined class="pa-3 my-3" v-if="userBusinessInformation">
      <h4 class="blue--text mb-3">اطلاعات تکمیلی</h4>
      <v-row>
        <v-col cols="12">
          <h5 class="body-1">درباره :</h5>
          <p
            v-if="userBusinessInformation.about"
            class="body-1"
            v-html="userBusinessInformation.about"
          ></p>
          <p v-else class="text--secondary">(وارد نشده)</p>
        </v-col>
          <v-col cols="12">
          <h5 class="body-1">خلاصه سئو پسند :</h5>
          <p
            v-if="userBusinessInformation.seoSummary"
            class="body-1"
           
          >{{  userBusinessInformation.seoSummary}}</p>
          <p v-else class="text--secondary">(وارد نشده)</p>
        </v-col>
        <v-col cols="12">
          <business-information-text-data
            :img="
                userBusinessInformation.logo
                ? userBusinessInformation.logo.fileUrl
                : null
            "
            :flex="false"
            label="لوگو :"
          />
        </v-col>
        <v-col cols="12">
          <business-information-text-data
            label="عکس پشت زمینه :"
            :img="
              userBusinessInformation.backgroundImage
                ? userBusinessInformation.backgroundImage.thumbnailFileUrl
                : null
            "
            :flex="false"
          />
        </v-col>

        <v-col cols="12">
          <business-information-text-data label="عکس های منتخب :" :flex="false">
            <div
              class="d-flex flex-wrap gap-1"
              v-if="
                userBusinessInformation.images &&
                userBusinessInformation.images.length
              "
            >
              <div
                class="image-input"
                v-for="(img, index) in userBusinessInformation.images"
                :key="index"
              >
                <a
                  :href="img.thumbnailFileUrl"
                  target="_blank"
                  class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                  data-action="change"
                  data-toggle="tooltip"
                  title=""
                  data-original-title="Change avatar"
                >
                  <i class="fa fa-eye icon-sm text-muted"></i>
                </a>
                <img
                  :src="img.thumbnailFileUrl"
                  style="width: 150px; border-radius: 5px"
                />
              </div>
            </div>
            <span v-else class="text--secondary">(وارد نشده)</span>
          </business-information-text-data>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import BusinessInformationTextData from './BusinessInformationTextData.vue';
export default {
  components: {
    BusinessInformationTextData,
  },
  props: {
    userBusinessInformation: {
      type: Object,
      default: null,
    },
  },
  methods: {},
};
</script>

<style></style>
